import React, { useEffect, useRef, useState } from 'react';
import { InvitesBtn } from './invitesBtn';
import { InvitesList } from './invitesList';
import { useInvites } from '../hooks/useInvites';
import { InvitesDoNotDisturbSwitcher } from './invitesDoNotDisturbSwitcher';
import { ITable } from '../../game/model/interfaces';
import { useClickOutside } from '@utils/hooks';
import styles from '../styles/invites.module.scss';
import { t } from '@base/utils/helpers';

export const Invites = () => {
  const { tables, count, doNotDisturb, disturbHandle, joinTable } = useInvites();
  const [showInvites, setShowInvites] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setShowInvites(false));

  function acceptInvite(table: ITable) {
    joinTable(table);
    setShowInvites(false);
  }

  return (
    <div className={styles.invites} ref={ref}>
      <InvitesBtn handleShow={setShowInvites} count={count} doNotDisturb={doNotDisturb} />
      {showInvites && (
        <div className={styles.body}>
          {!!count && <InvitesHeader />}
          {!!count && <InvitesList tables={tables} joinTable={acceptInvite} />}
          <div className={styles.switcher}>
            <InvitesDoNotDisturbSwitcher doNotDisturb={doNotDisturb} disturbHandle={disturbHandle} />
          </div>
        </div>
      )}
    </div>
  );
};

const InvitesHeader = () => (
  <div className={styles.header}>
    {['player', 'rating', 'points', 'tickets'].map((title) => (
      <div key={title}>{t(title)}</div>
    ))}
  </div>
);
